import React from 'react';
import { Portal } from '../../wag-react/components/Portal';
import LoadingBoneSpinner from '../../wag-react/components/loading-boner-spinner';
import { Flex } from '../../wag-react/next-components/Flex';
export const PageLoadingSpinner = () => <Portal data-sentry-element="Portal" data-sentry-component="PageLoadingSpinner" data-sentry-source-file="index.tsx">
    <Flex position="fixed" justifyContent="center" top="0" left="0" right="0" bottom="0" zIndex={1400} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <LoadingBoneSpinner data-sentry-element="LoadingBoneSpinner" data-sentry-source-file="index.tsx" />
    </Flex>
  </Portal>;